import React from 'react'

import {Container} from '~/components/general/container/Container'
import {Typography} from '~/components/general/typography/Typography'
import {Button} from '~/components/general/button/Button'
import {Modal} from '~/components/general/modal/Modal'

type SlotTakenModalProps = {
  isVisible: boolean
  onClose: () => void
  onOk: () => void
  isLoading: boolean
  header: string
  body: string
  okLabel: string
}

export const SlotTakenModal: React.FC<SlotTakenModalProps> = ({
  isVisible,
  onClose,
  onOk,
  isLoading,
  header,
  body,
  okLabel,
}) => (
  <Modal
    header={header}
    footer={
      <Container flex justify="flex-end" align="center">
        <Button color="secondary" onClick={onOk} disabled={isLoading}>
          {okLabel}
        </Button>
      </Container>
    }
    isVisible={isVisible}
    onClose={onClose}>
    <Container direction="column" spacing={1}>
      <Typography>{body}</Typography>
    </Container>
  </Modal>
)
